import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'

import { Overview } from 'components/misc'
import { DashboardGrid as Grid } from 'components/layout'
import {
  apiDashboard,
  apiDownloadFile,
  apiAssessors
} from 'helpers/decorators/api'
import { AssessorRejectSection } from 'components/modals'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import styles from '../../../components/layout/MaterialControlBar/material-control-bar.styl'
import { FormattedMessage } from 'react-intl'

@modal.trigger()
@apiDashboard.apiActivity()
@apiDashboard.apiAdventurousJourney()
@apiDashboard.apiResidentialProject()
@apiDashboard.apiAwards()
@apiAssessors()
@apiDownloadFile()
class ActivityOverviewAssessor extends Component {
  static propTypes = {
    onGetOverview: PropTypes.func.isRequired,
    activityOverview: PropTypes.object,
    params: PropTypes.object,
    residentialProject: PropTypes.object,
    onOpen: PropTypes.func,
    activity: PropTypes.object,
    journey: PropTypes.object,
    award: PropTypes.object,
    activityAssessorRejection: PropTypes.func,
    ajEventAssessorRejection: PropTypes.func,
    onLoadParticipants: PropTypes.func.isRequired,
    rpAssessorRejection: PropTypes.func,
    isAJ: PropTypes.bool,
    onAcceptActivity: PropTypes.func
  }

  static defaultProps = {
    params: {}
  }

  state = {
    canAdd: true
  }

  componentWillMount() {
    const { params } = this.props

    if (params && params.activityId) {
      this.handleLoadOverview(params.activityId)
    }
  }

  componentWillUpdate(nextProps) {
    const { params } = this.props

    if (
      get(params, 'activityId') &&
      get(params, 'activityId') !== get(nextProps.params, 'activityId')
    ) {
      this.handleLoadOverview(get(nextProps.params, 'activityId'))
    }
  }

  handleLoadOverview = activityId => this.props.onGetOverview(activityId)

  handleStopAssessing = fields => {
    const { residentialProject, onAcceptActivity, params } = this.props

    const isAccepted = false

    const activityId = get(params, 'activityId') ? get(params, 'activityId') : null

    const residentialProjectId = get(residentialProject, 'id') ? get(residentialProject, 'id') : null

    return onAcceptActivity(fields, isAccepted, activityId, residentialProjectId)
  }

  handleSuccess = () => {
    this.props.onOpen(null, null, null)
    this.props.onLoadParticipants()
  }

  render() {
    const {
      activityOverview,
      award,
      activity,
      journey,
      residentialProject,
      isAJ
    } = this.props
    const colorClass = getActivityClassName(
      get(activity, 'activitySection.value')
    )

    const aim =
      (get(journey, 'aim') || get(journey, 'ajEvent.aim')) ||
      get(residentialProject, 'goal') ||
      get(activityOverview, 'data.aim')
    const startDate =
      get(journey, 'ajEvent.startDate') ||
      get(residentialProject, 'startDate') ||
      get(activityOverview, 'data.startDate')
    const endDate =
      get(journey, 'ajEvent.endDate') || get(residentialProject, 'endDate')
    const activitySection =
      (journey && ACTIVITY_SECTIONS.adventurous_journey.id) ||
      get(residentialProject, 'activitySection.value') ||
      get(activity, 'activitySection.value')
    const leaderName =
      get(award, 'awardLeader.name') || get(award, 'awardLeader.person.name')
    const leaderPhone =
      get(award, 'awardLeader.phone') || get(award, 'awardLeader.person.phone')
    const leaderEmail = get(award, 'awardLeader.person.email')
    const orgName = get(award, 'awardLeader.organization.name')
    const journeyAct = get(journey, 'ajEvent.activityCategory.translatedName')
    const journeyTransport = get(
      journey,
      'ajEvent.modeOfTransportType.translationText'
    )
    const locationType = get(
      residentialProject,
      'projectLocationType.translationText'
    )
    const location =
      get(journey, 'ajEvent.country.name') ||
      get(residentialProject, 'locationDetail')
    const participantName = [
      get(award, 'participant.title'),
      get(award, 'participant.firstName'),
      get(award, 'participant.middleName'),
      get(award, 'participant.lastName')
    ]
      .filter(item => item)
      .join(' ')


    const note = get(journey, 'ajEvent.note') || get(residentialProject, 'note')

    return (
      <Grid.RightInner white>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <Overview
              activityOverview={activityOverview}
              activitySection={activitySection}
              title="Participant Details"
              titleKey="moduleTitle.participant_details"
              content={[
                {
                  id: '10',
                  content: participantName,
                  intlKey: 'label.name',
                  label: 'Name',
                  ico: 'face'
                }
              ]}
            />
            <Overview
              activityOverview={activityOverview}
              activitySection={activitySection}
              title="Activity Detail"
              titleKey={
                isAJ
                  ? 'moduleTitle.journey_details'
                  : 'moduleTitle.activity_details'
              }
              content={[
                {
                  id: '00',
                  content: aim,
                  intlKey: 'label.goal',
                  label: 'Goal',
                  ico: 'flag'
                },
                {
                  id: '01',
                  content: startDate,
                  intlKey: 'label.start_date',
                  label: 'Start Date',
                  ico: 'date',
                  date: true
                },
                endDate && {
                  id: '02',
                  content: endDate,
                  intlKey: 'label.end_date',
                  label: 'End Date',
                  ico: 'date',
                  date: true
                },
                journeyAct && {
                  id: '03',
                  content: journeyAct,
                  intlKey: 'label.journey_activity',
                  label: 'Journey Activity',
                  ico: 'filter-hdr'
                },
                journeyTransport && {
                  id: '04',
                  content: journeyTransport,
                  intlKey: 'label.mode_of_transport',
                  label: 'Mode of Transport',
                  ico: 'bike'
                },
                location && {
                  id: '05',
                  content: location,
                  intlKey: 'label.location',
                  label: 'Location',
                  ico: 'map'
                },
                locationType && {
                  id: '06',
                  content: locationType,
                  intlKey: 'label.location_type',
                  label: 'Location Type',
                  ico: 'info'
                },
                {
                  id: '07',
                  content: note,
                  intlKey: 'label.note',
                  label: 'Note',
                  ico: 'subject'
                }
              ]}
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <Overview
              activityOverview={activityOverview}
              activitySection={activitySection}
              title="Leader Details"
              titleKey="moduleTitle.leader_details"
              content={[
                {
                  id: '12',
                  content: leaderName,
                  intlKey: 'label.leader_name',
                  label: 'Leader Name',
                  ico: 'info'
                },
                {
                  id: '13',
                  content: leaderPhone,
                  intlKey: 'label.leader_phone',
                  label: 'Leader Phone',
                  ico: 'phone'
                },
                {
                  id: '14',
                  content: leaderEmail,
                  intlKey: 'label.leader_email',
                  label: 'Leader Email',
                  ico: 'email'
                }
              ]}
            />

            <Overview
              activityOverview={activityOverview}
              activitySection={activitySection}
              title="Award Unit Details"
              titleKey="moduleTitle.au_details"
              content={[
                {
                  id: '12',
                  content: orgName,
                  intlKey: 'label.au_name',
                  label: 'Award Unit Name',
                  ico: 'info'
                }
              ]}
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            {(get(activity, 'isAcceptedByAssessor') ||  get(residentialProject, 'isAcceptedByAssessor')) && <button
              type="button"
              className={styles.clear}
              onClick={() =>
                this.props.onOpen(MODALS.STOP_ASSESSING_SECTION, null, null)}
            >
              <i className={`ico ico--close ${styles.clearIcon}`} />
              <FormattedMessage id='button.stop_assessing_this_activity' defaultMessage='STOP ASSESSING THIS ACTIVITY' />
            </button>}

          </div>
        </div>

        <AssessorRejectSection
          modalId={MODALS.STOP_ASSESSING_SECTION}
          colorClass={colorClass}
          onConfirm={this.handleStopAssessing}
        />
      </Grid.RightInner>
    )
  }
}

export default ActivityOverviewAssessor
